import type { ColumnDef } from "@tanstack/react-table";
import { SkeletonLoader } from "@/components/Table";

const DASHBOARD_SKELETON_ROW_COUNT = 3;

function dashboardSkeletonColumns(columnCount: number): ColumnDef<unknown>[] {
  return Array.from({ length: columnCount }, (_, index) => ({
    id: `dashboard-skeleton-col-${index}`,
    header: ""
  }));
}

type DashboardTableSkeletonProps = {
  columnCount: number;
  rowCount?: number;
};

export default function DashboardTableSkeleton({
  columnCount,
  rowCount = DASHBOARD_SKELETON_ROW_COUNT
}: DashboardTableSkeletonProps) {
  return <SkeletonLoader columns={dashboardSkeletonColumns(columnCount)} rowCount={rowCount} />;
}
